import {andThen, Decoder, fail, string, succeed} from 'json-bouncer'

export type ShippingMethod = 'standard' | 'express'

export function shippingMethodDecoder(): Decoder<ShippingMethod> {
    return andThen(
        value => {
            switch (value) {
                case 'standard':
                    const standard: ShippingMethod = 'standard'
                    return succeed(standard)
                case 'express':
                    const express: ShippingMethod = 'express'
                    return succeed(express)
                default:
                    return fail(`Invalid shipping method: ${value}`)
            }
        },
        string())
}

export function label(shippingMethod: ShippingMethod): string {
    switch (shippingMethod) {
        case 'standard':
            return 'Standard'
        case 'express':
            return 'Express'
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ShippingMethod.ts